// import axios from './axios.config';

export const saveToken = (token: string): void => {
  localStorage.setItem('token', token);
  // axios.defaults.headers['Authorization-Token'] = token;
};

export const getToken = (): string | undefined => {
  // const searchParams = new URLSearchParams(window.location.search);
  // if (searchParams.has('token')) {
  //   const tokenFromSearchParams = `Bearer ${searchParams.get('token')}`;
  //   localStorage.setItem('token', tokenFromSearchParams);
  //   searchParams.delete('token');
  //   window.location.search = '';
  //   window.location.href = '/dashboard';
  //   return tokenFromSearchParams;
  // }

  const tokenFromLocalStorage = localStorage.getItem('token');
  const fullToken = 'Bearer ' + tokenFromLocalStorage;

  return (!!tokenFromLocalStorage as boolean) ? (fullToken as string) : undefined;
};

export const removeToken = (): void => localStorage.removeItem('token');
